export default {
    namespaced: true,
    state: {
        technologies: [],
        errors: {
            getTechnologies: ''
        }
    },
    getters: {
        nameTechnology: state => id => {
            const technology = state.technologies.find(item => {
                return parseInt(item.TechnologyID) === parseInt(id)
            })

            return technology ? technology.Name : ''
        }
    },
    mutations: {
        SET_TECHNOLOGIES(state, payload) {
            state.technologies = payload
        },
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        }
    },
    actions: {
        async getTechnologies({ commit }) {
            commit('SET_ERRORS', {
                key: 'getTechnologies',
                val: ''
            })

            const url = '/public/dict/technologies'

            try {
                const resp = await this.$axios.get(url).then(res => {
                    return res.data
                })

                commit('SET_TECHNOLOGIES', resp)
            } catch (e) {
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getTechnologies',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getTechnologies',
                        val: 'Ошибка'
                    })
                }
            }
        }
    }
}
